"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/test-detailed-report.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Ftest-detailed-report.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountSpec = exports.ReportSpec = void 0;
const insight_1 = require("./insight");
const protobufPackage = 'com.step.creditreport.insight.report.test.proto';
function createBaseReportSpec() {
    return { vendor: insight_1.InsightVendor.INVALID_VENDOR, accounts: [] };
}
exports.ReportSpec = {
    fromJSON(object) {
        const message = {
            vendor: isSet(object.vendor)
                ? (0, insight_1.insightVendorFromJSON)(object.vendor)
                : insight_1.InsightVendor.INVALID_VENDOR,
            accounts: globalThis.Array.isArray(object?.accounts)
                ? object.accounts.map((e) => exports.AccountSpec.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.vendor !== insight_1.InsightVendor.INVALID_VENDOR) {
            obj.vendor = (0, insight_1.insightVendorToJSON)(message.vendor);
        }
        if (message.accounts?.length) {
            obj.accounts = message.accounts.map((e) => exports.AccountSpec.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.ReportSpec.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReportSpec();
        message.vendor = object.vendor ?? insight_1.InsightVendor.INVALID_VENDOR;
        message.accounts = object.accounts?.map((e) => exports.AccountSpec.fromPartial(e)) || [];
        return message;
    },
};
function createBaseAccountSpec() {
    return { isStepAccount: false, isClosed: false };
}
exports.AccountSpec = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.isStepAccount)) {
            message.isStepAccount = globalThis.Boolean(object.isStepAccount);
        }
        if (isSet(object.isClosed)) {
            message.isClosed = globalThis.Boolean(object.isClosed);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isStepAccount !== undefined && message.isStepAccount !== false) {
            obj.isStepAccount = message.isStepAccount;
        }
        if (message.isClosed !== undefined && message.isClosed !== false) {
            obj.isClosed = message.isClosed;
        }
        return obj;
    },
    create(base) {
        return exports.AccountSpec.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountSpec();
        message.isStepAccount = object.isStepAccount ?? false;
        message.isClosed = object.isClosed ?? false;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=test-detailed-report.js.map